// Exact hero palette and radial order: claret outside, violet at the core.
export const TWIN_PIGMENTS = ["#D91B5C", "#E8501C", "#D49A00", "#00A56A", "#008FB8", "#7456E8"];
export const RADII = [43, 35.5, 28, 20.5, 13, 5.5];
const noise = (seed: number) => {
  const value = Math.sin(seed * 127.1 + 311.7) * 43758.5453;
  return value - Math.floor(value);
};
const n = (value: number) => value.toFixed(2);
const dot = (x: number, y: number, radius: number) => `M${n(x - radius)} ${n(y)}a${n(radius)} ${n(radius)} 0 1 0 ${n(radius * 2)} 0a${n(radius)} ${n(radius)} 0 1 0 ${n(-radius * 2)} 0`;

export const PARTICLE_LAYERS = RADII.map((radius, layer) => {
  let ordered = "";
  let cloud = "";
  for (let track = 0; track < 3; track++) {
    const r = radius + (track - 1) * 2.1;
    const count = Math.max(12, Math.round(r * 2.65));
    for (let i = 0; i < count; i++) {
      const seed = layer * 997 + track * 211 + i;
      const angle = (i + track * .35 + noise(seed + 7) * .7) / count * Math.PI * 2;
      const jitter = (noise(seed) - .5) * 2.2;
      const size = .66 + noise(seed + 3) * .34;
      ordered += dot(60 + Math.cos(angle) * (r + jitter), 60 + Math.sin(angle) * (r + jitter), size);
      const cloudAngle = noise(seed + 11) * Math.PI * 2;
      const cloudRadius = Math.sqrt(noise(seed + 23)) * 45;
      cloud += dot(60 + Math.cos(cloudAngle) * cloudRadius, 60 + Math.sin(cloudAngle) * cloudRadius, size);
    }
  }
  return { ordered, cloud };
});
